// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]

const state = {
  options: {
    levels: [
      {label: '一线城市', value: 1},
      {label: '新一线城市', value: 2},
      {label: '二线城市', value: 3},
      {label: '三线城市', value: 4},
      {label: '四线城市', value: 5},
      {label: '五线城市', value: 6},
    ],
  },
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {}

export const cityMap = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/city-map/city-map.store.js